<app-medias [dataFn]="fetchMedias" [userDTO]="userDTO()" />
